export class GetBubblesRequest {
    ActiveOnly: boolean;
}
